import { useContext } from "react";
import { useIsOnline } from "./useIsOnline";
import { GlobalContext } from "../../state/contexts/globalState";

export const useGlobal = () => {
  return { ...useContext(GlobalContext), ...useIsOnline() };
};
